/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Photo_ChangeInputs */



/**
* | output |
* | --- |
* | "Change photo" |
*
* @param {Settings_Photo_ChangeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_photo_change = /** @type {((inputs?: Settings_Photo_ChangeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Photo_ChangeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Foto wijzigen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier la photo")
	return /** @type {LocalizedString} */ ("Change photo")
});